import React, { useEffect, useMemo, useRef, useState } from "react";
import "./App.css";
import wishlistBanner from "./images/wishlist banner.png";
import discordBanner from "./images/discord.png";
import reverieExterior from "./images/crimson reverie outside bg.png";
import blurredReverie from "./images/blurred bg.png";
import ravenFullbody from "./images/sprites/cropped/fullbody raven.png";
import mattyFullbody from "./images/sprites/cropped/fullbody matty.png";
import ravenHeadshot from "./images/sprites/cropped/headshot raven flirty.png";
import mattyHeadshot from "./images/sprites/cropped/headshot matty flirty.png";
import jennySprite from "./images/sprites/cropped/jenny winking.png";
import jennyHeadshot from "./images/sprites/jenny headshot.png";
import gridGameArt from "./images/interactive/bv-grid-game.jpg";

const STEAM_URL =
  "https://store.steampowered.com/app/3997150/Brothel_Virgin__The_Crimson_Reverie/";
const DISCORD_URL = "https://discord.gg/YgXNFUaEAC";
const ITCH_URL = "https://moxegames.itch.io/brothel-virgin";
const GOFUNDME_WIDGET_URL =
  "https://www.gofundme.com/f/help-me-repair-my-crumblind-house-wall-before-winter/widget/large?attribution_id=sl%3A7f666eac-d7cb-4462-ad5f-cb7989d58753";
const GOFUNDME_EMBED_SCRIPT = "https://www.gofundme.com/static/js/embed.js";
const AGE_GATE_KEY = "brothelVirginUkAgeVerified";
const SLIDESHOW_DELAY = 6500;
const GRID_COLUMNS = ["A", "B", "C", "D", "E", "F", "G", "H"];
const GRID_ROWS = ["1", "2", "3", "4", "5", "6", "7", "8"];
const CUM_MARK_FADE_OUT_MS = 12000;
const MOBILE_CUM_MARK_LIMIT = 160;
const GRID_CELLS = GRID_ROWS.flatMap((row) =>
  GRID_COLUMNS.map((column) => `${column}${row}`),
);
const emptyVoteResults = GRID_CELLS.reduce(
  (results, cell) => ({ ...results, [cell]: 0 }),
  {},
);
const routes = [
  {
    name: "Raven",
    eyebrow: "Futa femdom route",
    title: "Bold, dangerous, and very into tarot",
    body: "Raven is the confident companion for players looking for a futanari visual novel route with femdom energy, light BDSM, oral and anal H-scenes, futa on male content, and a hidden futa on female variant through a secret code or rare RNG easter egg.",
    tags: [
      "Futa on male",
      "Futa on female",
      "Femdom",
      "Tarot minigame",
      "Secret code",
    ],
    image: ravenFullbody,
    portrait: ravenHeadshot,
    align: "left",
  },
  {
    name: "Matty",
    eyebrow: "Elf mommy route",
    title: "Soft, nurturing, and hiding a potion shelf",
    body: "Matty is the warm mature elf route: a mommy fetish fantasy visual novel path with gentle seduction, potion mixing, breast expansion, lactation content, and a more intimate first-night mood.",
    tags: ["Mommy fetish", "Breast expansion", "Lactation", "Potion minigame"],
    image: mattyFullbody,
    portrait: mattyHeadshot,
    align: "right",
  },
  {
    name: "Jenny",
    eyebrow: "Hidden hostess encounter",
    title: "The receptionist has a VIP code",
    body: "Jenny is not one of the two main girls, but the Crimson Reverie's hostess can still be wooed through a hidden reservation path for a short, flirty office encounter.",
    tags: ["Hidden route", "VIP code", "Hostess scene", "Replay secret"],
    image: jennySprite,
    portrait: jennyHeadshot,
    align: "center",
  },
];

const featureCards = [
  {
    title: "Choose your first night",
    body: "Arrive at The Crimson Reverie on your 25th birthday, answer the Client-Companion Compatibility Questionnaire, make a reservation, or chase the hidden hostess code.",
  },
  {
    title: "Stop-motion H-scenes",
    body: "Animated NSFW scenes branch through oral, vaginal, anal, non-penetrative, futa, femdom, light BDSM, and fetish outcomes depending on who you follow.",
  },
  {
    title: "Minigames with consequences",
    body: "Pull Raven's tarot cards, mix Matty's fantasy potions, unlock replayable scenes, collect endings, and find out which choices open the VIP room.",
  },
];

const adultSearchTerms = [
  "adult sex visual novel",
  "NSFW fantasy visual novel",
  "brothel game",
  "prostitution game",
  "virgin game",
  "losing virginity visual novel",
  "futa on male",
  "futa on female",
  "futa blowjob game",
  "futanari visual novel",
  "female protagonist futa scene",
  "trans character adult game",
  "femdom game",
  "mistress domination game",
  "light BDSM visual novel",
  "anal sex visual novel",
  "mommy fetish game",
  "elf mommy visual novel",
  "breast expansion game",
  "lactation fetish game",
  "adult game with secret codes",
  "adult game with RNG easter eggs",
  "potion minigame adult VN",
  "tarot adult visual novel",
  "stop-motion H-scene game",
  "branching H-scene visual novel",
  "interactive kink game",
  "erotic fantasy VN",
];

const faqs = [
  {
    question: "What kind of adult game is Brothel Virgin?",
    answer:
      "Brothel Virgin: The Crimson Reverie is an adult fantasy sex visual novel about one surreal night in a brothel, with branching routes, stop-motion H-scenes, minigames, and replayable endings.",
  },
  {
    question: "Who are the main routes?",
    answer:
      "The two main companion routes are Raven, a bold futa/femdom tarot route with futa on male and hidden futa on female variants, and Matty, a nurturing elf mommy route with potion-based breast expansion and lactation content. Jenny, the hostess, is a hidden VIP encounter.",
  },
  {
    question: "Where can I wishlist Brothel Virgin?",
    answer:
      "You can wishlist Brothel Virgin: The Crimson Reverie on Steam, play the preview on Itch, and join the Discord for updates.",
  },
];

const screenshotNameSorter = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: "base",
});
const getScreenshotLabel = (name) => name.replace(/\.[^.]+$/, "");
const testImageFallback =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
const cumAssets = {};

if (process.env.NODE_ENV !== "test") {
  const cumContext = require.context("./images/cum", false, /\.(png|webp)$/i);

  for (const key of cumContext.keys()) {
    const name = key.replace("./", "");
    cumAssets[name] = cumContext(key);
  }
} else {
  cumAssets["cum_1.png"] = testImageFallback;
}

const cumAssetNames = Object.keys(cumAssets).sort((a, b) =>
  screenshotNameSorter.compare(a, b),
);
const cumAssetWidthPercent = {
  "cum_1.png": 2.686,
  "cum_2.png": 5.057,
  "cum_3.png": 5.686,
  "cum_4.png": 2.429,
  "cum_5.png": 6.114,
  "cum_6.png": 2.743,
  "cum_7.png": 5.914,
  "cum_8.png": 4.543,
  "cum_9.png": 3.257,
  "cum_10.png": 2.114,
  "cum_11.png": 5.286,
  "cum_12.png": 3.714,
  "cum_13.png": 3.714,
  "cum_14.png": 4.486,
  "cum_15.png": 2.743,
  "cum_16.png": 6.857,
  "cum_17.png": 3.314,
  "cum_18.png": 3.429,
  "cum_19.png": 4.343,
};
const screenshots = [];

if (process.env.NODE_ENV !== "test") {
  const screenshotContext = require.context(
    "./images/screenshots",
    false,
    /\.(png|jpe?g|webp)$/i,
  );

  for (const key of screenshotContext.keys()) {
    const name = key.replace("./", "");

    screenshots.push({
      label: getScreenshotLabel(name),
      name,
      src: screenshotContext(key),
    });
  }
} else {
  for (const name of ["1.png", "2.png", "3.png"]) {
    screenshots.push({
      label: getScreenshotLabel(name),
      name,
      src: testImageFallback,
    });
  }
}

screenshots.sort((a, b) =>
  screenshotNameSorter.compare(
    getScreenshotLabel(a.name),
    getScreenshotLabel(b.name),
  ),
);

const isLikelyUkVisitor = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const timeZone =
    Intl.DateTimeFormat().resolvedOptions().timeZone?.toLowerCase() || "";
  const languages = navigator.languages?.length
    ? navigator.languages
    : [navigator.language];

  return (
    timeZone === "europe/london" ||
    languages.some((language) => /-(gb|uk)$/i.test(language))
  );
};

const markMatchesFreshClick = (mark, freshMark) =>
  freshMark &&
  mark.cell === freshMark.cell &&
  mark.asset === freshMark.asset &&
  Math.abs(Number(mark.x) - Number(freshMark.x)) < 1 &&
  Math.abs(Number(mark.y) - Number(freshMark.y)) < 1;

const isLocalCumMark = (mark) =>
  typeof mark?.id === "string" && mark.id.startsWith("local-");

const isSameCumMark = (firstMark, secondMark) => {
  if (!firstMark || !secondMark) {
    return false;
  }

  if (
    !isLocalCumMark(firstMark) &&
    !isLocalCumMark(secondMark) &&
    firstMark.id === secondMark.id
  ) {
    return true;
  }

  return markMatchesFreshClick(firstMark, secondMark);
};

const mergeCumMarks = (serverMarks, currentMarks) => {
  const syncedMarks = Array.isArray(serverMarks) ? serverMarks : [];
  const syncedMarksWithStableIds = syncedMarks.map((mark) => {
    const matchingLocalMark = currentMarks.find(
      (currentMark) =>
        isLocalCumMark(currentMark) && markMatchesFreshClick(mark, currentMark),
    );

    if (matchingLocalMark) {
      return {
        ...mark,
        id: matchingLocalMark.id,
        isFresh: matchingLocalMark.isFresh,
      };
    }

    return mark;
  });
  const pendingLocalMarks = currentMarks.filter(
    (mark) =>
      isLocalCumMark(mark) &&
      !mark.isLeaving &&
      !syncedMarksWithStableIds.some((serverMark) =>
        markMatchesFreshClick(serverMark, mark),
      ),
  );
  const leavingMarks = currentMarks
    .filter(
      (mark) =>
        (mark.isLeaving &&
          !syncedMarksWithStableIds.some((serverMark) =>
            isSameCumMark(serverMark, mark),
          )) ||
        (!isLocalCumMark(mark) &&
          !syncedMarksWithStableIds.some((serverMark) =>
            isSameCumMark(serverMark, mark),
          )),
    )
    .map((mark) => ({
      ...mark,
      id: mark.id,
      isFresh: false,
      isLeaving: true,
      leavingSince: mark.leavingSince || Date.now(),
    }));

  return [...leavingMarks, ...syncedMarksWithStableIds, ...pendingLocalMarks];
};

const App = () => {
  const [showAgeGate, setShowAgeGate] = useState(false);
  const [accessDeclined, setAccessDeclined] = useState(false);
  const [activeScreenshot, setActiveScreenshot] = useState(0);
  const [slideDirection, setSlideDirection] = useState("next");
  const [selectedGridCell, setSelectedGridCell] = useState(null);
  const [voteResults, setVoteResults] = useState(emptyVoteResults);
  const [alltimeResults, setAlltimeResults] = useState(emptyVoteResults);
  const [cumMarks, setCumMarks] = useState([]);
  const [isMobileGameView, setIsMobileGameView] = useState(false);
  const [voteStatus, setVoteStatus] = useState("loading");
  const [rateLimitNotice, setRateLimitNotice] = useState("");
  const gridBoardRef = useRef(null);
  const autoAdvanceTimer = useRef(null);
  const fadeOutTimers = useRef({});
  const timerToken = useRef(0);
  const wheelLock = useRef(false);

  const currentYear = useMemo(() => new Date().getFullYear(), []);
  const activeScreenshotImage = screenshots[activeScreenshot] || screenshots[0];
  const rankedVoteResults = useMemo(
    () =>
      GRID_CELLS.map((cell) => ({
        cell,
        votes: voteResults[cell] || 0,
      }))
        .sort((a, b) => b.votes - a.votes || a.cell.localeCompare(b.cell))
        .slice(0, 8),
    [voteResults],
  );
  const rankedAlltimeResults = useMemo(
    () =>
      GRID_CELLS.map((cell) => ({
        cell,
        votes: alltimeResults[cell] || 0,
      }))
        .sort((a, b) => b.votes - a.votes || a.cell.localeCompare(b.cell))
        .slice(0, 5),
    [alltimeResults],
  );
  const alltimeFavorite = rankedAlltimeResults[0] || { cell: "A1", votes: 0 };
  const maxVoteCount = useMemo(
    () =>
      Math.max(1, ...GRID_CELLS.map((cell) => Number(voteResults[cell] || 0))),
    [voteResults],
  );
  const totalVoteCount = useMemo(
    () =>
      GRID_CELLS.reduce(
        (total, cell) => total + Number(voteResults[cell] || 0),
        0,
      ),
    [voteResults],
  );
  const visibleCumMarks = useMemo(() => {
    if (!isMobileGameView) {
      return cumMarks;
    }

    const pinnedMarks = cumMarks.filter(
      (mark) => isLocalCumMark(mark) || mark.isFresh || mark.isLeaving,
    );
    const ordinaryMarks = cumMarks.filter(
      (mark) => !isLocalCumMark(mark) && !mark.isFresh && !mark.isLeaving,
    );
    const newestOrdinaryMarks = ordinaryMarks.slice(-MOBILE_CUM_MARK_LIMIT);
    const visibleIds = new Set();

    return [...newestOrdinaryMarks, ...pinnedMarks].filter((mark) => {
      const id = String(mark.id);

      if (visibleIds.has(id)) {
        return false;
      }

      visibleIds.add(id);
      return true;
    });
  }, [cumMarks, isMobileGameView]);

  useEffect(() => {
    if (!isLikelyUkVisitor()) {
      return;
    }

    const verified = window.localStorage.getItem(AGE_GATE_KEY);
    setShowAgeGate(verified !== "yes");
  }, []);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) {
      return undefined;
    }

    const mediaQuery = window.matchMedia("(max-width: 760px)");
    const syncMobileGameView = () => setIsMobileGameView(mediaQuery.matches);

    syncMobileGameView();

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", syncMobileGameView);
      return () => mediaQuery.removeEventListener("change", syncMobileGameView);
    }

    mediaQuery.addListener(syncMobileGameView);
    return () => mediaQuery.removeListener(syncMobileGameView);
  }, []);

  useEffect(() => {
    if (typeof fetch !== "function") {
      setVoteStatus("offline");
      return;
    }

    fetch("./api/results.php")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Vote results unavailable");
        }

        return response.json();
      })
      .then((data) => {
        setVoteResults({ ...emptyVoteResults, ...(data.results || {}) });
        setAlltimeResults({
          ...emptyVoteResults,
          ...(data.alltime_results || {}),
        });
        setCumMarks((currentMarks) => mergeCumMarks(data.marks, currentMarks));
        setVoteStatus("ready");
      })
      .catch(() => {
        setVoteStatus("offline");
      });
  }, []);

  useEffect(() => {
    if (screenshots.length < 2) {
      return undefined;
    }

    const scheduledToken = timerToken.current;

    autoAdvanceTimer.current = window.setTimeout(() => {
      if (scheduledToken !== timerToken.current) {
        return;
      }

      autoAdvanceTimer.current = null;
      setSlideDirection("next");
      setActiveScreenshot((current) =>
        current === screenshots.length - 1 ? 0 : current + 1,
      );
    }, SLIDESHOW_DELAY);

    return () => window.clearTimeout(autoAdvanceTimer.current);
  }, [activeScreenshot]);

  useEffect(() => {
    const liveLeavingIds = new Set(
      cumMarks.filter((mark) => mark.isLeaving).map((mark) => String(mark.id)),
    );

    Object.keys(fadeOutTimers.current).forEach((id) => {
      if (!liveLeavingIds.has(id)) {
        window.clearTimeout(fadeOutTimers.current[id]);
        delete fadeOutTimers.current[id];
      }
    });

    cumMarks.forEach((mark) => {
      const id = String(mark.id);

      if (!mark.isLeaving || fadeOutTimers.current[id]) {
        return;
      }

      fadeOutTimers.current[id] = window.setTimeout(() => {
        setCumMarks((currentMarks) =>
          currentMarks.filter((currentMark) => String(currentMark.id) !== id),
        );
        delete fadeOutTimers.current[id];
      }, CUM_MARK_FADE_OUT_MS);
    });

    return undefined;
  }, [cumMarks]);

  useEffect(
    () => () => {
      Object.values(fadeOutTimers.current).forEach((timer) =>
        window.clearTimeout(timer),
      );
    },
    [],
  );

  useEffect(() => {
    if (
      typeof document === "undefined" ||
      document.querySelector(`script[src="${GOFUNDME_EMBED_SCRIPT}"]`)
    ) {
      return;
    }

    const script = document.createElement("script");
    script.defer = true;
    script.src = GOFUNDME_EMBED_SCRIPT;
    document.body.appendChild(script);
  }, []);

  const confirmAdult = () => {
    window.localStorage.setItem(AGE_GATE_KEY, "yes");
    setShowAgeGate(false);
  };

  const declineAdult = () => {
    window.localStorage.removeItem(AGE_GATE_KEY);
    setShowAgeGate(false);
    setAccessDeclined(true);
  };

  const pauseAutoAdvance = () => {
    timerToken.current += 1;

    if (autoAdvanceTimer.current) {
      window.clearTimeout(autoAdvanceTimer.current);
      autoAdvanceTimer.current = null;
    }
  };

  const showPreviousScreenshot = () => {
    if (screenshots.length < 2) {
      return;
    }

    pauseAutoAdvance();
    setSlideDirection("previous");
    setActiveScreenshot((current) =>
      current === 0 ? screenshots.length - 1 : current - 1,
    );
  };

  const showNextScreenshot = () => {
    if (screenshots.length < 2) {
      return;
    }

    pauseAutoAdvance();
    setSlideDirection("next");
    setActiveScreenshot((current) =>
      current === screenshots.length - 1 ? 0 : current + 1,
    );
  };

  const showScreenshot = (index) => {
    if (index === activeScreenshot) {
      return;
    }

    pauseAutoAdvance();
    setSlideDirection(index > activeScreenshot ? "next" : "previous");
    setActiveScreenshot(index);
  };

  const handleScreenshotWheel = (event) => {
    if (Math.abs(event.deltaY) < 18 || wheelLock.current) {
      return;
    }

    wheelLock.current = true;

    if (event.deltaY > 0) {
      showNextScreenshot();
    } else {
      showPreviousScreenshot();
    }

    window.setTimeout(() => {
      wheelLock.current = false;
    }, 620);
  };

  const chooseGridCell = (cell, event) => {
    const board = gridBoardRef.current;
    const rect = board?.getBoundingClientRect();
    const columnIndex = GRID_COLUMNS.indexOf(cell[0]);
    const rowIndex = GRID_ROWS.indexOf(cell[1]);
    const fallbackX = ((columnIndex + 0.5) / GRID_COLUMNS.length) * 100;
    const fallbackY = ((rowIndex + 0.5) / GRID_ROWS.length) * 100;
    const x =
      rect && event?.clientX
        ? Math.min(
            100,
            Math.max(0, ((event.clientX - rect.left) / rect.width) * 100),
          )
        : fallbackX;
    const y =
      rect && event?.clientY
        ? Math.min(
            100,
            Math.max(0, ((event.clientY - rect.top) / rect.height) * 100),
          )
        : fallbackY;
    const asset =
      cumAssetNames[Math.floor(Math.random() * cumAssetNames.length)] ||
      "cum_1.png";
    const localMark = {
      id: `local-${Date.now()}-${Math.random().toString(36).slice(2)}`,
      cell,
      x,
      y,
      asset,
      opacity: 1,
      isFresh: true,
    };

    setSelectedGridCell(cell);
    setCumMarks((currentMarks) => [...currentMarks, localMark]);
    window.setTimeout(() => {
      setCumMarks((currentMarks) =>
        currentMarks.map((mark) =>
          mark.id === localMark.id ? { ...mark, isFresh: false } : mark,
        ),
      );
    }, 520);
    setVoteResults((currentResults) => ({
      ...currentResults,
      [cell]: Number(currentResults[cell] || 0) + 1,
    }));
    setAlltimeResults((currentResults) => ({
      ...currentResults,
      [cell]: Number(currentResults[cell] || 0) + 1,
    }));
    setVoteStatus("saving");

    if (typeof fetch !== "function") {
      setVoteStatus("offline");
      return;
    }

    fetch("./api/vote.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ asset, cell, x, y }),
    })
      .then((response) => {
        return response.json().then((data) => {
          if (!response.ok) {
            const error = new Error("Mark failed");
            error.status = response.status;
            error.data = data;
            throw error;
          }

          return data;
        });
      })
      .then((data) => {
        setVoteResults({ ...emptyVoteResults, ...(data.results || {}) });
        setAlltimeResults({
          ...emptyVoteResults,
          ...(data.alltime_results || {}),
        });
        setCumMarks((currentMarks) => mergeCumMarks(data.marks, currentMarks));
        setVoteStatus("saved");
      })
      .catch((error) => {
        if (error?.status === 429 && error.data) {
          setVoteResults({
            ...emptyVoteResults,
            ...(error.data.results || {}),
          });
          setAlltimeResults({
            ...emptyVoteResults,
            ...(error.data.alltime_results || {}),
          });
          setCumMarks((currentMarks) =>
            mergeCumMarks(
              error.data.marks,
              currentMarks.map((mark) =>
                mark.id === localMark.id
                  ? {
                      ...mark,
                      isFresh: false,
                      isLeaving: true,
                      leavingSince: Date.now(),
                    }
                  : mark,
              ),
            ),
          );
          setRateLimitNotice(
            error.data.error ||
              "Woah slow down cowboy. Get a glass of water and come back in an hour to finish.",
          );
          setVoteStatus("limited");
          return;
        }

        setVoteStatus("offline");
      });
  };

  return (
    <div
      className="site-shell"
      style={{
        "--page-bg": `url(${blurredReverie})`,
        "--hero-cover": `url(${reverieExterior})`,
      }}
    >
      <header className="site-header" aria-label="Primary">
        <a className="brand-mark" href="#top" aria-label="Brothel Virgin home">
          <img src="/icons/bv_image.png" alt="" />
          <span>Brothel Virgin</span>
        </a>
        <nav className="nav-links" aria-label="Landing page sections">
          <a href="#routes">Routes</a>
          <a href="#spot-game">Game</a>
          <a href="#screenshots">Screens</a>
          <a href="#faq">FAQ</a>
          <a href="#community">Discord</a>
        </nav>
        <a
          className="header-cta"
          href={STEAM_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Wishlist on Steam
        </a>
      </header>

      <main id="top">
        <section
          className="hero-section"
          aria-labelledby="hero-title"
          style={{
            "--hero-cover": `url(${reverieExterior})`,
          }}
        >
          <div className="hero-copy">
            <p className="eyebrow">
              Adult stop-motion fantasy sex visual novel
            </p>
            <h1 id="hero-title">Brothel Virgin</h1>
            <p className="game-subtitle">The Crimson Reverie</p>
            <p className="hero-lede">
              Welcome to your first night at The Crimson Reverie: a surreal
              adult brothel game where a compatibility questionnaire, a secret
              reservation code, and one risky choice can decide who takes you to
              the VIP room.
            </p>

            <div className="hero-actions" aria-label="Main calls to action">
              <a
                className="primary-button"
                href={STEAM_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Wishlist on Steam
              </a>
              <a
                className="secondary-button"
                href={ITCH_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Play the preview
              </a>
            </div>

            <dl className="quick-stats" aria-label="Game highlights">
              <div>
                <dt>Routes</dt>
                <dd>Raven, Matty, and hidden Jenny</dd>
              </div>
              <div>
                <dt>Scenes</dt>
                <dd>Stop-motion adult H-scenes</dd>
              </div>
              <div>
                <dt>Play</dt>
                <dd>Tarot, potions, choices, endings</dd>
              </div>
            </dl>
          </div>
        </section>

        <section className="steam-banner-section" aria-label="Steam wishlist">
          <a
            className="image-banner wishlist-banner"
            href={STEAM_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={wishlistBanner}
              alt="Wishlist Brothel Virgin: The Crimson Reverie on Steam"
            />
          </a>
        </section>

        <section className="intro-section section-block">
          <div>
            <p className="eyebrow">The first visit</p>
            <h2>Your reservation is stranger than expected.</h2>
          </div>
          <div className="intro-copy">
            <p>
              Brothel Virgin starts with a simple problem: the player promised
              himself he would not stay a virgin past his 25th birthday. That
              promise leads him to The Crimson Reverie, where Jenny greets him,
              the CCCQ tries to find his perfect companion, and the night starts
              slipping into fantasy.
            </p>
            <p>
              This is an erotic fantasy VN built around direct adult choices:
              futa on male encounters, mommy fetish intimacy, light BDSM,
              potion-based breast expansion and lactation, and hidden route
              secrets for players who replay.
            </p>
          </div>
        </section>

        <section className="routes-section section-block" id="routes">
          <div className="section-heading">
            <div>
              <p className="eyebrow">Companion routes</p>
              <h2>Two main girls. One hostess who can be wooed.</h2>
            </div>
          </div>

          <div className="route-grid">
            {routes.map((route) => (
              <article
                className={`route-card route-card-${route.align}`}
                key={route.name}
              >
                <div className="route-art">
                  <img className="route-fullbody" src={route.image} alt="" />
                  <img className="route-portrait" src={route.portrait} alt="" />
                </div>
                <div className="route-copy">
                  <p className="eyebrow">{route.eyebrow}</p>
                  <h3>{route.name}</h3>
                  <p className="route-title">{route.title}</p>
                  <p>{route.body}</p>
                  <ul className="tag-list" aria-label={`${route.name} themes`}>
                    {route.tags.map((tag) => (
                      <li key={tag}>{tag}</li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section
          className="feature-grid"
          id="features"
          aria-label="Game features"
        >
          {featureCards.map((feature) => (
            <article className="feature-card" key={feature.title}>
              <h2>{feature.title}</h2>
              <p>{feature.body}</p>
            </article>
          ))}
        </section>

        <section
          className="grid-game-section section-block"
          id="spot-game"
          aria-labelledby="spot-game-title"
        >
          <div className="section-heading">
            <div>
              <p className="eyebrow">Community finish map</p>
              <h2 id="spot-game-title">WelCUM to your first night!</h2>
            </div>
            <p className="section-note">
              {totalVoteCount.toLocaleString()} marks still wet
            </p>
          </div>

          <div className="grid-game-layout">
            <div className="grid-game-board">
              <div className="grid-image-frame" ref={gridBoardRef}>
                <img
                  className="grid-game-art"
                  src={gridGameArt}
                  alt=""
                  loading="lazy"
                  decoding="async"
                />
                <div className="cum-mark-layer" aria-hidden="true">
                  {visibleCumMarks.map((mark) => (
                    <img
                      alt=""
                      decoding="async"
                      loading="lazy"
                      className={[
                        "cum-mark",
                        mark.isFresh ? "is-fresh" : "",
                        mark.isLeaving ? "is-leaving" : "",
                      ]
                        .filter(Boolean)
                        .join(" ")}
                      key={mark.id}
                      src={cumAssets[mark.asset] || cumAssets["cum_1.png"]}
                      style={{
                        "--mark-width": `${cumAssetWidthPercent[mark.asset] || 4}%`,
                        "--mark-opacity": mark.opacity,
                        left: `${mark.x}%`,
                        top: `${mark.y}%`,
                      }}
                    />
                  ))}
                </div>
                <div className="grid-axis grid-axis-x" aria-hidden="true">
                  {GRID_COLUMNS.map((column) => (
                    <span key={column}>{column}</span>
                  ))}
                </div>
                <div className="grid-axis grid-axis-y" aria-hidden="true">
                  {GRID_ROWS.map((row) => (
                    <span key={row}>{row}</span>
                  ))}
                </div>
                <div className="grid-overlay" aria-label="Choose a square">
                  {GRID_CELLS.map((cell) => {
                    const intensity = Math.max(
                      0.12,
                      Number(voteResults[cell] || 0) / maxVoteCount,
                    );

                    return (
                      <button
                        aria-label={`Pick square ${cell}`}
                        className="grid-cell"
                        key={cell}
                        onClick={(event) => chooseGridCell(cell, event)}
                        style={{
                          "--heat": intensity.toFixed(3),
                        }}
                        type="button"
                      />
                    );
                  })}
                </div>
              </div>
            </div>

            <aside className="grid-game-results">
              <p className="eyebrow">Your turn to aim</p>
              <h3>
                {selectedGridCell
                  ? `You came on ${selectedGridCell}`
                  : "Where do you finish?"}
              </h3>
              <p>
                Your first night with the three gals. Pick any spot and mark it
                as yours. Fresh marks fade each day and vanish after 5 days.
              </p>
              <p className="ranking-label">Freshest hot spots</p>
              <ol className="vote-ranking">
                {rankedVoteResults.map(({ cell, votes }) => (
                  <li key={cell}>
                    <span>{cell}</span>
                    <meter max={maxVoteCount} min="0" value={votes} />
                    <strong>{votes.toLocaleString()}</strong>
                  </li>
                ))}
              </ol>
              <p className="vote-status">
                {voteStatus === "loading" && "Loading picks..."}
                {voteStatus === "ready" && "The board is ready for you."}
                {voteStatus === "saving" && "Saving your mark..."}
                {voteStatus === "saved" && "Your mark is on the board."}
                {voteStatus === "limited" &&
                  "You reached the 100 marks per hour cap. Give the girls a breather."}
                {voteStatus === "offline" &&
                  "Preview mode: upload the API files and database config to save live results."}
              </p>
            </aside>
          </div>

          <div className="alltime-panel">
            <div className="alltime-favorite">
              <span>All-time favorite</span>
              <strong>{alltimeFavorite.cell}</strong>
              <small>
                {alltimeFavorite.votes.toLocaleString()} total marks
              </small>
            </div>
            <div className="alltime-list">
              <p className="ranking-label">All-time leaderboard</p>
              <ol className="vote-ranking vote-ranking-compact">
                {rankedAlltimeResults.map(({ cell, votes }) => (
                  <li key={cell}>
                    <span>{cell}</span>
                    <meter
                      max={Math.max(1, alltimeFavorite.votes)}
                      min="0"
                      value={votes}
                    />
                    <strong>{votes.toLocaleString()}</strong>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </section>

        <section
          className="screenshots-section"
          id="screenshots"
          aria-labelledby="screens-title"
        >
          <div className="section-heading">
            <div>
              <p className="eyebrow">In-game screenshots</p>
              <h2 id="screens-title">Scenes from The Crimson Reverie</h2>
            </div>
          </div>

          <div className="screenshot-viewer" onWheel={handleScreenshotWheel}>
            <div
              className={`screenshot-preview slide-${slideDirection}`}
              onClick={showNextScreenshot}
              role="button"
              tabIndex="0"
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  showNextScreenshot();
                }
              }}
              aria-label="Show next screenshot"
            >
              <img
                key={activeScreenshotImage.name}
                src={activeScreenshotImage.src}
                alt={`Brothel Virgin in-game screenshot ${activeScreenshot + 1}`}
              />
              <div
                className="screenshot-controls"
                aria-label="Screenshot controls"
                onClick={(event) => event.stopPropagation()}
                onKeyDown={(event) => event.stopPropagation()}
              >
                <button
                  type="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    showPreviousScreenshot();
                  }}
                >
                  Prev
                </button>
                <span>
                  {activeScreenshot + 1} / {screenshots.length}
                </span>
                <button
                  type="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    showNextScreenshot();
                  }}
                >
                  Next
                </button>
              </div>
            </div>
          </div>

          <div className="screenshot-dots" aria-label="Choose screenshot">
            {screenshots.map((screenshot, index) => (
              <button
                className={
                  index === activeScreenshot
                    ? "screenshot-dot is-active"
                    : "screenshot-dot"
                }
                key={screenshot.name}
                type="button"
                onClick={() => showScreenshot(index)}
                aria-label={`Show screenshot ${index + 1}`}
                aria-pressed={index === activeScreenshot}
              />
            ))}
          </div>
        </section>

        <section className="adult-seo-section section-block">
          <div className="section-heading">
            <div>
              <p className="eyebrow">Adult visual novel themes</p>
              <h2>Built for adult VN and fetish game fans.</h2>
            </div>
          </div>
          <p className="seo-copy">
            Brothel Virgin: The Crimson Reverie is an adult sex visual novel for
            players searching for a fantasy brothel game, prostitution game,
            virgin game, erotic fantasy VN, futanari visual novel, femdom game,
            futa on male, futa on female, mommy fetish game, breast expansion
            game, lactation fetish game, secret-code adult scenes, RNG easter
            eggs, and stop-motion H-scene game with branching choices.
          </p>
          <ul className="keyword-cloud" aria-label="Adult game themes">
            {adultSearchTerms.map((term) => (
              <li key={term}>{term}</li>
            ))}
          </ul>
        </section>

        <section className="faq-section section-block" id="faq">
          <div className="section-heading">
            <div>
              <p className="eyebrow">FAQ</p>
              <h2>Before you enter</h2>
            </div>
          </div>
          <div className="faq-grid">
            {faqs.map((faq) => (
              <article className="faq-card" key={faq.question}>
                <h3>{faq.question}</h3>
                <p>{faq.answer}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="community-section" id="community">
          <a
            className="image-banner discord-banner"
            href={DISCORD_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Join Discord"
          >
            <img src={discordBanner} alt="" />
          </a>
        </section>
      </main>

      <footer className="site-footer">
        <span>&copy; {currentYear} MoxeGames. All rights reserved.</span>
        <span>Brothel Virgin: The Crimson Reverie is for adults 18+ only.</span>
      </footer>

      {rateLimitNotice && (
        <div
          className="rate-limit-popup"
          role="alertdialog"
          aria-live="assertive"
        >
          <p>{rateLimitNotice}</p>
          <button type="button" onClick={() => setRateLimitNotice("")}>
            Okay
          </button>
        </div>
      )}

      {showAgeGate && (
        <div className="age-gate" role="dialog" aria-modal="true">
          <div className="age-gate-panel">
            <p className="eyebrow">UK age confirmation</p>
            <h2>Are you 18 or older?</h2>
            <p>
              This adult game site contains mature sexual themes and is intended
              only for adults. Please confirm before entering.
            </p>
            <div className="age-gate-actions">
              <button type="button" onClick={confirmAdult}>
                Yes, enter
              </button>
              <button
                type="button"
                className="ghost-button"
                onClick={declineAdult}
              >
                No, leave
              </button>
            </div>
          </div>
        </div>
      )}

      {accessDeclined && (
        <div className="age-gate" role="dialog" aria-modal="true">
          <div className="age-gate-panel">
            <p className="eyebrow">Access restricted</p>
            <h2>You must be 18 or older to view this site.</h2>
            <p>This page is only for adults and will stay hidden.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
